import makeStyles from '@ui/utils/makeStyles';

type StyleProps = {
  open: boolean;
}

export default makeStyles<StyleProps>()((theme, { open }) => ({
  perspectiveWrapper : {
    perspective: '2000px',
    width: '100vw',
    height: 'calc(100vh - 80px)',
    top: 80,
    left: 0,
    zIndex: 40,
    position: 'fixed',
    backgroundColor: theme.palette.common.white,
    visibility : open ? 'visible': 'hidden',
  },
  wrapper: {
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 80px)',
    overflow: 'auto',
    transition: 'all .3s',
    color: theme.palette.common.black,
    transformOrigin: 'top',
    backgroundColor: theme.palette.common.white,
    transform: open ? 'rotateX(0deg)' : 'rotateX(-15deg)',
    opacity: open ? 1 : 0,
    transformStyle: 'preserve-3d',
    position: 'relative',

    '& a': {
      textDecoration: 'none',
      color: theme.palette.common.black,
    },
  },
  screen: {
    padding: theme.spacing(0, 3, 3, 3),
    position: 'absolute',
    top: 0,
    left: 0,
    minHeight: 'calc(100vh - 80px)',
    height: '100%',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },

}));
